import type Phaser from "phaser";
import { STAGE } from "./stage";

// DOM overlays use the same fitted painting as the canvas, even on a tall phone.
export function followCanvasLayout(game: Phaser.Game): void {
  const shell = document.querySelector<HTMLElement>("#app-shell")!;
  const refresh = () => {
    const canvas = game.canvas.getBoundingClientRect(), parent = shell.getBoundingClientRect();
    shell.style.setProperty("--game-scale", String(canvas.width / STAGE.width));
    shell.style.setProperty("--game-width", `${canvas.width}px`);
    shell.style.setProperty("--game-height", `${canvas.height}px`);
    shell.style.setProperty("--game-left", `${canvas.left - parent.left}px`);
    shell.style.setProperty("--game-top", `${canvas.top - parent.top}px`);
  };
  const observer = new ResizeObserver(refresh);
  observer.observe(shell); observer.observe(game.canvas);
  game.scale.on("resize", refresh);
  game.events.once("destroy", () => { observer.disconnect(); game.scale.off("resize", refresh); });
  refresh();
}
